// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay for modal background */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Darker overlay for focus */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

/* Modal content box */
.modal-content {
    background: #FFFFFF;
    padding: 30px;
    border-radius: 12px;
    width: 500px;
    max-width: 90%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
    position: relative;
    text-align: center;
}

/* Close button */
.close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 24px;
    color: #6B7280;
    cursor: pointer;
    transition: color 0.3s ease;
}

.close-button:hover {
    color: #FF0000;
}

/* Modal heading */
.modal-content h2 {
    margin-bottom: 20px;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
}

/* Input fields styling */
.modal-content select,
.modal-content input[type="text"],
.modal-content textarea {
    width: 100%;
    padding: 12px;
    margin-bottom: 15px;
    border: 1px solid #DFE7EF;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    color: #4B5563;
}

.modal-content select:focus,
.modal-content input[type="text"]:focus,
.modal-content textarea:focus {
    border-color: #FF0000;
}

/* Upload button */
.upload-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    margin-top: 10px;
    border: 1px dashed #FF0000;
    color: #FF0000;
    background: #FFEFEF;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: background 0.3s ease, color 0.3s ease;
}

.upload-button:hover {
    background: #FF0000;
    color: #FFFFFF;
}

/* Submit button styling */
.submit-button {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: none;
    background-color: #FF0000;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 20px;
}

.submit-button:hover {
    background-color: #E60000;
}

.category-select {
    width: 100%;
    margin-bottom: 16px;
}

/* Responsive adjustments */
@media (max-width: 500px) {
    .modal-content {
        padding: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/AddInstructionModal.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,6BAA6B;IAC7D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,yCAAyC,EAAE,4BAA4B;IACvE,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;;;IAGI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,cAAc;AAClB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Overlay for modal background */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Darker overlay for focus */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n/* Modal content box */\n.modal-content {\n    background: #FFFFFF;\n    padding: 30px;\n    border-radius: 12px;\n    width: 500px;\n    max-width: 90%;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */\n    position: relative;\n    text-align: center;\n}\n\n/* Close button */\n.close-button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #6B7280;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.close-button:hover {\n    color: #FF0000;\n}\n\n/* Modal heading */\n.modal-content h2 {\n    margin-bottom: 20px;\n    font-size: 20px;\n    color: #333333;\n    font-weight: bold;\n}\n\n/* Input fields styling */\n.modal-content select,\n.modal-content input[type=\"text\"],\n.modal-content textarea {\n    width: 100%;\n    padding: 12px;\n    margin-bottom: 15px;\n    border: 1px solid #DFE7EF;\n    border-radius: 8px;\n    font-size: 14px;\n    outline: none;\n    color: #4B5563;\n}\n\n.modal-content select:focus,\n.modal-content input[type=\"text\"]:focus,\n.modal-content textarea:focus {\n    border-color: #FF0000;\n}\n\n/* Upload button */\n.upload-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    margin-top: 10px;\n    border: 1px dashed #FF0000;\n    color: #FF0000;\n    background: #FFEFEF;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background 0.3s ease, color 0.3s ease;\n}\n\n.upload-button:hover {\n    background: #FF0000;\n    color: #FFFFFF;\n}\n\n/* Submit button styling */\n.submit-button {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: none;\n    background-color: #FF0000;\n    color: #FFFFFF;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 20px;\n}\n\n.submit-button:hover {\n    background-color: #E60000;\n}\n\n.category-select {\n    width: 100%;\n    margin-bottom: 16px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 500px) {\n    .modal-content {\n        padding: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
